module.exports = (theme) => ({
  ".text": {
    fontSize: theme("fontSize.base"),
    fontFamily: theme("fontFamily.regular"),
    fontWeight: theme("fontWeight.regular"),
    lineHeight: theme("lineHeight.base"),
  },
});
